import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ChevronDown, FileText, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, formatApiError } from "@/lib/api";

const fileUrl = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/contracts/${id}/file`;

export const PayslipArchive = ({ onOpenEmployee }) => {
  const [groups, setGroups] = useState([]);
  const [open, setOpen] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/contracts/payslips/archive").then((r) => { setGroups(r.data); setOpen(r.data[0]?.periodo || null); }).catch((e) => toast.error(formatApiError(e))); }, []);
  if (groups.length === 0) return null;
  const match = (i) => !q || i.employee_name.toLowerCase().includes(q.toLowerCase());
  return (
    <div className="panel p-6 space-y-4" data-testid="payslip-archive">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div><p className="eyebrow">Archivio cedolini per mese</p><p className="mt-1 text-sm text-slate-500">Buste paga arrivate via email o caricate, divise per dipendente. Clicca un mese per vederle.</p></div>
        <div className="relative sm:w-64"><Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" /><Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca dipendente" className="pl-9" data-testid="payslip-archive-search" /></div>
      </div>
      <ul className="divide-y divide-slate-100 rounded-md border border-slate-200">
        {groups.map((g) => {
          const items = g.items.filter(match);
          if (q && items.length === 0) return null;
          const isOpen = open === g.periodo || !!q;
          return (
            <li key={g.periodo} data-testid={`payslip-month-${g.key}`}>
              <button type="button" onClick={() => setOpen(isOpen && !q ? null : g.periodo)} className="flex w-full items-center justify-between px-4 py-3 text-left hover:bg-slate-50" data-testid={`payslip-month-toggle-${g.key}`}>
                <span className="font-medium text-slate-900">{g.periodo}</span>
                <span className="flex items-center gap-3 text-xs text-slate-500">{items.length} buste <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? "rotate-180" : ""}`} /></span>
              </button>
              {isOpen && (
                <ul className="grid grid-cols-1 gap-1 px-4 pb-3 sm:grid-cols-2 lg:grid-cols-3">
                  {items.map((i) => (
                    <li key={i.id} className="flex items-center justify-between gap-2 rounded-md bg-slate-50 px-3 py-2 text-sm" data-testid={`payslip-item-${i.id}`}>
                      <button type="button" onClick={() => i.employee_id && onOpenEmployee?.(i.employee_id)} className="truncate text-left font-medium text-slate-800 hover:underline">{i.employee_name}</button>
                      <a href={fileUrl(i.id)} target="_blank" rel="noreferrer" className="inline-flex shrink-0 items-center gap-1 text-xs text-[#3d6e49] hover:underline" data-testid={`payslip-view-${i.id}`}><FileText className="h-3.5 w-3.5" /> Vedi</a>
                    </li>))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
